module.exports = __webpack_public_path__ + "media/icons/mp4@2x-1d0b7e56.png";